export const getPercentageProgress = (hours, totalHours) => {
  const percentage = Math.round((hours * 100) / totalHours);
  const realDiff = 100 - percentage;

  return [percentage, realDiff];
};
